'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _header = require('./header');

var _header2 = _interopRequireDefault(_header);

var _name = require('./name');

var _name2 = _interopRequireDefault(_name);

var _rules = require('./rules');

var _rules2 = _interopRequireDefault(_rules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (header, name, rules) {
	var strings = [];

	strings.push((0, _header2.default)(header));
	strings.push((0, _name2.default)(name));
	strings.push('\n');
	strings.push.apply(strings, _toConsumableArray((0, _rules2.default)(rules)));

	return strings.reduce(function (str, item) {
		// pass through whitespace
		if (/^\s+$/.test(item)) {
			return '' + str + item;
		}
		return '' + str + (str ? '\n' : '') + item + ';';
	}, '');
};


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/stringify/index.js
// module id = 198
// module chunks = 0